import React, { useState, useEffect } from "react";
// import Banner from "elements/Banner";
import { Link } from "react-router-dom";
import api from "services/api";
import Pagination from "elements/Pagination";
import { __ } from "services/Translator";
import GamesFilter from "elements/games_elements/GamesFilter";
import StoreFilterBar from "elements/StoreFilterBar";

export default function Stores(props) {
  const [alertMsg, setAlertMsg] = useState({
    message: "Successfully added",
    variant: "success",
    showAlert: false,
  });

  // const [recentArticleData, setRecentArticleData] = useState({});
  // const getStoresData = async (ev) => {
  //   var response = await api.get("/products");
  //   if (response.status === 200) {
  //     setRecentArticleData(response.data.data);
  //   }
  //   console.log("articleData", response.data);
  // };

  // useEffect(() => {
  //   getStoresData();
  // }, []);

  //pagination data

  const [activePage, setActivePage] = useState(1);
  const [page, setPage] = useState(1);

  const pageNum = (receiveVal) => {
    setPage(receiveVal);
  };

  const [productsData, setProductsData] = useState([]);
  const [productsDataPagination, setProductsDataPagination] = useState([]);
  const getProductsData = async (ev) => {
    var response = await api.post("/products", {
      page: page,
      perPage: 8,
    });
    if (response.status === 200) {
      setActivePage(page);
      setProductsData(response.data.data);
      setProductsDataPagination(response.data.paginationData);
    }
    // console.log("productsData", response.data);
  };
  useEffect(() => {
    getProductsData();
  }, [page]);

  const buyProduct = async (id) => {
    props.setSpinner(true);
    var response = await api.post("/buy-product", { product_id: id });
    // console.log(response);
    props.setSpinner(false);
    if (response.status == 200) {
      props.showAlert(__("Success"), response.data.message, false, null, 5000);
    } else {
      props.showAlert(__("Error!!"), response.data.message, true);
    }
  };

  const onPageChange = (page) => {
    setPage(page);
  };

  const products = [
    {
      id: 1,
      label: "New",
      title: "100 Bonus Money",
      price: "Coins",
      imageUrl: require("assets/images/store/5.png").default,
      showButton: false,
    },
    {
      id: 2,
      title: "400 Bonus Money",
      price: "Coins",
      imageUrl: require("assets/images/store/4.png").default,
      showButton: false,
    },
    {
      id: 3,
      title: "400 Bonus Money",
      price: "Coins",
      imageUrl: require("assets/images/store/3.png").default,
      showButton: true,
    },
    {
      id: 4,
      title: "Mystery Box",
      price: "Coins",
      imageUrl: require("assets/images/store/2.png").default,
      showButton: false,
    },
    {
      id: 5,
      title: "Bonus Spin",
      price: "Coins",
      imageUrl: require("assets/images/store/1.png").default,
      showButton: false,
    },
    {
      id: 5,
      title: "Bonus Spin",
      price: "Coins",
      imageUrl: require("assets/images/store/6.png").default,
      showButton: false,
    },
  ];

  return (
    <>
      <div className="container-xxl">
        <section className={"banner "}>
          {/* <div className="banner_left"></div> */}
          <div className="banner_content">
            <div className="single_banner">
              <div className="banner_middle">
                {/* <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div> */}
                <div className="headline">
                  {__("Wellcome to")} <br /> {__("Our Store")}
                </div>
                <div className="quotedHeadline">{__("No Any Slot Game")}</div>
                <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on"
                  )}
                </div>

                <div className="banner_count ">
                  {props.totals && (
                    <>
                      <div className="count_area">
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalPlayers}+
                          </div>
                          <div className="paragraph">{__("Players Online")}</div>
                        </div>
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalGames}+
                          </div>
                          <div className="paragraph">{__("Games")}</div>
                        </div>
                      </div>
                    </>
                  )}
                  {props.isAuthenticated ? (
                    <Link
                      to="/games/slots"
                      className={"angle_btn " + props.landingType}
                    >
                      {__("Play Now")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="red"
                        class="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </Link>
                  ) : (
                    <Link
                      onClick={() => {
                        props.setModalSignUpPropsData(true);
                      }}
                      className={"angle_btn " + props.landingType}
                    >
                      {__("Sign Up Now")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="red"
                        class="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </Link>
                  )}
                </div>
              </div>
              <div className={"banner_img " + props.landingType}>
                <img
                  alt="game image"
                  src={require("assets/images/banners/store-comp.png").default}
                />
              </div>
            </div>
            {!props.isMobileDeviceByViewPort && (
              <div className="banner_features_list">
                <div className="single_item">{__("01. Best Quality")}</div>
                <div className="single_item">{__("02. Secure Payment")}</div>
                <div className="single_item">{__("03. Fast Pay - Outs")}</div>
                <div className="single_item">{__("04. Return Guarantee")}</div>
                <div className="single_item">{__("05. Support Customer")}</div>
              </div>
            )}
          </div>
        </section>

        <GamesFilter gameDropdown={false} {...props} />

        {!props.isMobileDeviceByViewPort && <StoreFilterBar {...props} />}
        <section className="products-area">
          <div className="product-cards-container">
            {productsData.length > 0 &&
              productsData.map((product) => (
                <div key={product.id} className="product-card">
                  {product.label && (
                    <div className="label">{product.label}</div>
                  )}
                  <img
                    src={product.background_path}
                    alt={product.title}
                    className="product-image"
                  />
                  <div className="product-details">
                    <h3 className="product-name">{product.title}</h3>
                    <p className="product-price">Price: {product.price}</p>

                    <button
                      onClick={() => buyProduct(product.id)}
                      className="buy-button"
                    >
                      Buy Product
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </section>
        <div className="products margin_top_30 margin_bottom_30 d-none">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="products_headine margin_bottom_15">
                  {__("Products")}
                  <span className="dashed"></span>
                </div>

                <div className="product_lists margin_bottom_15">
                  {productsData.length > 0 &&
                    productsData.map((value, index) => (
                      <div className="single_product">
                        <div className="product_img">
                          <img
                            className="single_games_img"
                            src={value.background_path}
                          />
                        </div>
                        <div className="product_details">
                          <h3 className="product_heading">{value.title}</h3>
                          {value.free_spins && (
                            <h3 className="product_part_info">
                              {value.free_spins} {__("Free Spins")}
                            </h3>
                          )}

                          {value.bonus_money && (
                            <h3 className="product_part_info">
                              {value.bonus_money} {__("Bonus Money")}
                            </h3>
                          )}

                          {value.cash_money && (
                            <h3 className="product_part_info">
                              {value.cash_money} {__("Cash Money")}
                            </h3>
                          )}

                          {value.price && (
                            <h3 className="product_part_info">
                              {" "}
                              {__("Price")}: {value.price}{" "}
                              {value.price > 1 ? "Coins" : "Coin"}
                            </h3>
                          )}
                        </div>
                        <Link
                          onClick={() => buyProduct(value.id)}
                          className={
                            "angle_btn big margin_0_auto " + props.landingType
                          }
                        >
                          {__("buy product")}
                        </Link>
                      </div>
                    ))}
                </div>

                <Pagination
                  data={productsDataPagination}
                  onPageChange={onPageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
